class BreakpointHelper {
    /**
     * check whether a passed breakpoint was crossed and in case
     * it was, if the screen's size is now above the breakpoint
     * @param breakpoint
     * @param aboveBreakpoint
     * @returns {{aboveBreakpoint: boolean, breakpointCrossed: boolean}}
     */
    static breakpointCrossed(breakpoint, aboveBreakpoint = false) {
        let breakpointCrossed = false;

        if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
            if (!aboveBreakpoint) {
                aboveBreakpoint = true;
                breakpointCrossed = true;
            }
            return { aboveBreakpoint, breakpointCrossed };
        }

        if (aboveBreakpoint) {
            aboveBreakpoint = false;
            breakpointCrossed = true;
        }

        return { aboveBreakpoint, breakpointCrossed };
    }

    /**
     * returns if the screen's size is above a passed breakpoint
     * @param breakpoint
     * @returns {boolean}
     */
    static aboveBreakpoint(breakpoint) {
        return window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
    }
}

export default BreakpointHelper;
